import { createStyles } from "@material-ui/core";

const buttonStyles = createStyles({
  actions: { display: "flex", justifyContent: "flex-end", gap: "12px" },
  cancelBtn: {
    borderColor: "#E5B611",
    textTransform: "none",
    color: "#1e1e1e",
    height: "32px",
    boxShadow: "none",
    "&:hover": { boxShadow: "none", borderColor: "#E5B611" },
  },
  submitBtn: {
    backgroundColor: "#E5B611",
    textTransform: "none",
    height: "32px",
    color: "#1e1e1e",
    boxShadow: "none",
    "&:hover": { boxShadow: "none", backgroundColor: "#E5B611" },
  },
});

export { buttonStyles };
